export const CREATE_TOKEN            = 'CREATE_TOKEN'
export const UPDATE_VIEW             = 'UPDATE_VIEW'
export const SHOW_SMALL_BOX          = 'SHOW_SMALL_BOX'
export const HIDE_SMALL_BOX          = 'HIDE_SMALL_BOX'
export const CREATE_DISABILITY_USER  = 'CREATE_DISABILITY_USER'
export const SAVE_EMAIL              = 'SAVE_EMAIL'
export const FILE_OVERLAYER_SEEN     = 'FILE_OVERLAYER_SEEN'
export const UPDATE_ARTICLE_RATINGS  = 'UPDATE_ARTICLE_RATINGS'
export const UPDATE_PAGE_COUNTER     = 'UPDATE_PAGE_COUNTER'
